// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3x_gs","title":"Info_title__1KKvp","selects":"Info_selects__1FX0i","requiredAsterisk":"Info_requiredAsterisk__2AKWp"};